import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import APIImportView from '../view/APIImportView';

class APIImport extends React.Component {
	constructor(props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	onSelect(fileOrURL) {
		this.props.actions.validateSwagger(fileOrURL, this.props.type);
	}

	onSave(importOptions) {
		this.props.actions.saveEndpoint(importOptions);
	}

	componentWillUnmount() {
		this.props.actions.importApiCancel();
	}

	onCancel() {
		this.props.actions.importApiCancel();
	}

	render() {
		const {
			error,
			errorDetail,
			validating,
			valid,
			currentSpec,
			importedSpec,
			data,
			apiSpecTypes,
			type,
			specId
		} = this.props;

		return (
			<APIImportView
				loading={validating}
				error={error}
				errorDetail={errorDetail}
				currentSpec={currentSpec}
				importedSpec={importedSpec}
				type={type}
				specId={specId}
				data={data}
				valid={valid}
				apiSpecTypes={apiSpecTypes}
				onCancel={this.onCancel}
				onFileSelect={this.onSelect}
				onUrlSelect={this.onSelect}
				onSave={this.onSave}
			/>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	const importDetail = state.apidocs.importDetail;
	const apiSpecTypes = state.apidocs.apiSpecTypes;
	return {
		validating: importDetail.validating,
		valid: importDetail.valid,
		importedSpec: importDetail.parsedSpec,
		type: importDetail.type,
		data: importDetail.data,
		// Note that errors could come as a result of importing/validating the
		// spec (stored in importDetails) or as a result of saving the spec on
		// disk (stored in apidocs).
		error: state.apidocs.error || importDetail.error,
		errorDetail: state.apidocs.errorDetail || importDetail.errorDetail,
		apiSpecTypes: apiSpecTypes.types
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(APIImport);
